import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import {
  MultiSelect, MultiSelectOption, RadioButton, RadioButtonGroup,
} from '@ipc/ipc-components';
import { FormattedMessage } from 'react-intl';
import OPERATORS from '../constants/operators';
import { sortValues } from '../helpers/sortValues';
import ColumnFilter from './ColumnFilter';

const initialCurrent = {
  operator: OPERATORS.CONTAINS,
  string: '',
  valid: false,
};

class TextFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      multiSelectOptions: this.getOrderedUniqueValues(props),
    };
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { data } = this.props;
    if (!_.isEqual(nextProps.data, data)) {
      this.setState({
        multiSelectOptions: this.getOrderedUniqueValues(nextProps),
      });
    }
  }

  getOrderedUniqueValues = (props) => _(props.data)
    .map((row) => {
      const value = props.column.accessor(row);
      if (!value || value === '') {
        return new MultiSelectOption(null, '(Blank)');
      }

      return new MultiSelectOption(value);
    })
    .uniqBy('value')
    .value()
    .sort(sortValues);

  isValid = (multiSelectValues, string) => (multiSelectValues && multiSelectValues.length > 0) || !!string;

  render() {
    const { multiSelectOptions } = this.state;
    return (
      <ColumnFilter
        {...this.props}
        render={(current = initialCurrent, setCurrent) => (
          <div>
            <div className="advanced-filter__fields">
              <MultiSelect
                value={current.multiSelectValues}
                onChange={(value) => setCurrent({
                  ...current,
                  multiSelectValues: value,
                  valid: this.isValid(value, current.string),
                })}
                options={multiSelectOptions}
              />
            </div>
            <div className="advanced-filter__fields">
              <RadioButtonGroup
                onChange={(event, operator) => {
                  setCurrent({
                    ...current,
                    operator,
                  });
                }}
                name="textFilter"
                value={current.operator}
              >
                <RadioButton
                  value={OPERATORS.CONTAINS}
                  label={<FormattedMessage id="filter-component.label.contains" />}
                />
                <RadioButton
                  value={OPERATORS.STARTS_WITH}
                  label={<FormattedMessage id="filter-component.label.starts-with" />}
                />
              </RadioButtonGroup>
            </div>

            <div className="advanced-filter__fields">
              <input
                className="text-input"
                onChange={(event) => setCurrent({
                  ...current,
                  string: event.target.value,
                  valid: this.isValid(current.multiSelectValues, event.target.value),
                })}
                value={current.string}
              />
            </div>
          </div>
        )}
      />
    );
  }
}

TextFilter.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
};

export default TextFilter;
